import { useCallback } from 'react';

import { debounce } from 'underscore';

/**
 * @deprecated this doesn't actually debounce anything. It still fires it after
 * a delay
 */
const useDebouncedCallback = <TCallback extends (...args: any[]) => any>({
  callback,
  interval,
  dependencies,
}: {
  callback: TCallback;
  interval: number;
  dependencies: any[];
  // eslint-disable-next-line react-hooks/exhaustive-deps
}) => useCallback(debounce(callback, interval), dependencies);

export { useDebouncedCallback };
